// Shared label formatters for departments and roles

const ACRONYMS = new Set(['vfx', 'sfx', 'dit', 'dp', 'ad']);

export function formatLabel(text = '') {
  if (!text) return '';
  // normalize: kebab-case or snake_case to words
  const words = String(text)
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/);
  return words
    .map((w) => {
      const lw = w.toLowerCase();
      if (ACRONYMS.has(lw)) return lw.toUpperCase();
      return lw.charAt(0).toUpperCase() + lw.slice(1);
    })
    .join(' ');
}

export const formatDepartmentLabel = formatLabel;
export const formatRoleLabel = formatLabel;
